import { RemoteDeleteUser } from 'data/usecases';
import { makeApiUrlUsers } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteDeleteUser = (): RemoteDeleteUser => {
  return new RemoteDeleteUser(makeApiUrlUsers(), makeAxiosHttpClient());
};
